import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    worker: null,
    isSuccess: null,
    isError: null,
    isLoading: null,
    message: '',
};

export const selectedWorkerSlice = createSlice({
    name: "selectedWorker",
    initialState,
    reducers: {
        //Call the reset function when the workers page is rendered
        reset: (state) => initialState,

        setSelectedWorker: (state, action) => {
            state.worker = action.payload;
            state.isSuccess = true;
            state.isError = false;
            state.message = 'worker selected';
            state.isLoading = false;
        },
    },
});

export const { setSelectedWorker,reset } = selectedWorkerSlice.actions;
export default selectedWorkerSlice.reducer;
